import React from 'react'
import Image from '../../../images/buyerpolicies/Exchange Policy.png'

const Exchange_policy = () => {
  return (
    <div className='sp_details_wrapper'>
      <div className='sp_details_container'>
        <div className='sp_details_image'>
            <img src={Image} alt='policy'/>
        </div>
        <div className='sp_details_details'>
            <h2>Exchange Policy</h2>
            <h5>Exchange is easy as Shopping with KAAY</h5>
            <p>We at KAAY want to be sure that our customers are always happy and satisfied. No matter what, we choose to bring comfort in your lives. The KAAY is constantly looking for novel ways to introduce something unique to cater to the increasing needs of our valued customers. We strive to provide each and every order with perfection, every detail meeting the client’s preferences and delivered on time. However, despite of this, there are still times the customers are not happy.</p>
            <p>We have a perfect replace and exchange policy to address this issue. If you have chosen to go for a replacement, we can help you! However, there are certain conditions you can be considered to get a replacement. Some of them include:</p>
            <ul>
                <li>•	You did not get a product matching your order, product is not as a picture or as described, due to our mistake.</li>
                <li>•	You mistakenly ordered a product which had a defect and it has been delivered.</li>
            </ul>
            <h5>Note</h5>
            <p>change of mind is not applicable to the exchange policy.</p>
            <p>Here are some more facilities for replacement/exchange of products offered by KAAY.</p>
            <h5>Return Within 7 Days</h5>
            <p>If you have identified the defect or wrong product, it is recommended to hurry up! There is a total duration of seven days after delivery to inform us about the replacement/exchange.</p>
            <h5>Send Back Your Order</h5>
            <p>You can return the order and let us know via email to csr@kaay.pk, describing your order ID. Make sure you send the courier within 07 days of delivery.</p>
            <h5>Return Charges</h5>
            <p>The courier to return the product is going to be paid by the seller.</p>
            <h5>What you should take care of before return</h5>
            <p>Before you return the items, make sure they are undamaged and not used at all. Merchandise that has been worn, used, or altered will not be accepted for exchange. </p>
            <p>Send the product with original product packaging, warranty cards, documentation, manufacturer’s containers, manuals and everything you received with the order. Make sure nothing is marked or defaced in the list of items provided.</p>
            <h5>Return / Refund</h5>
            <p>We do not offer returns/refund. We do not offer money back guarantee on any of purchase. And we will not entertain any return/refund query.</p>
            <p><br></br><br></br>Please note damage does not include any issue with the product pertaining to the style/design of the product. Bleeding and rubbing of dyes is not a defect. Similarly, minor stitching issues in may occur even after rigorous quality checks. This may happen during the undergoing packing process & will not be considered as a defect.</p>
        </div>
      </div>
    </div>
  )
}

export default Exchange_policy
